import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {},
  headLine: {
    fontWeight: 'bold',
    fontSize: 14,
    listStyle: 'none',
    marginBottom: theme.spacing(1),
  },
  isLoading: {
    width: 20,
    height: 20,
    position: 'absolute',
    right: '28px',
    top: '43px',
  },
  flexField: {
    display: 'flex',
  },
  profile: {
    background: ' #eef1f5',
    display: 'inline-block',
    padding: '17px 16px 10px',
    borderRadius: '5px',
    width: '33%',
    border: '1px solid #e5e6e7',
    '@media(max-width: 1280px)': {
      width: '50%',
    },
    '@media(max-width: 955px)': {
      width: '100%',
    },
  },
  radioBtn: {
    padding: '8px 10px!important ',
    '& .MuiFormLabel-root': {
      fontSize: '12px',
      color: '#5c5c5c',
    }
  },
  usageItem: {
    fontSize: 12,
    fontWeight: 'normal',
    listStyle: 'none',
    marginBottom: 5,
    marginInlineStart: theme.spacing(1),
    position: 'relative',
    paddingInlineStart: theme.spacing(1.5),
    '&::before': {
      content: `" "`,
      position: 'absolute',
      left: 0,
      top: 6,
      width: 5,
      height: 5,
      borderRadius: 4,
    },
  },
  addBusinessBtn: {
    borderRadius: '8px',
    width: '100%',
    borderTopLeftRadius: '8px!important', borderBottomLeftRadius: '8px!important',
    height: 43,

    '@media(min-width: 992px)': {
      width: '50%',
    },
    '@media(min-width: 1100px)': {
      borderRadius: '8px',
      borderTopLeftRadius: '0!important', borderBottomLeftRadius: '0!important',

      width: 'auto',

    },
  },
  chips: {
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(2),
    },
  },
  addButton: {
    color: theme.palette.secondary.dark,
  },
  chip: {
    marginBottom: 8,
    marginInlineEnd: 5,
    backgroundColor: '#f6f7f8',
    maxWidth: '100%',
    '&:hover': {
      backgroundColor: '#eaeef3',
    },
    '&.disableDelete': {
      backgroundColor: '#e2e5e9',
    },
  },
  addVoucherWrapper: {
    position: 'static',
    '@media(max-width: 992px)': {
      marginTop: 25,
    },
  },
  invoiceExtrasRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    gap: 8,
    width: '100%',
    '@media(max-width: 600px)': {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  taxField: {
    flex: '0 0 calc(25% - 6px)',
    minWidth: 0,
    '@media(max-width: 1099px)': {
      flexBasis: 'calc(50% - 4px)',
    },
    '@media(max-width: 600px)': {
      flexBasis: 'auto',
      width: '100%',
    },
  },
  voucherControl: {
    display: 'flex',
    alignItems: 'flex-end',
    flex: '0 0 calc(25% - 6px)',
    minWidth: 0,
    '@media(max-width: 1099px)': {
      flexBasis: 'calc(50% - 4px)',
    },
    '@media(max-width: 600px)': {
      flexBasis: 'auto',
      width: '100%',
    },
    '& > div': {
      flex: '1 1 auto',
      minWidth: 0,
    },
    '& > button': {
      position: 'static',
      flex: '0 0 auto',
      top: 'auto',
      margin: 0,
      height: 43,
      '@media(min-width: 1100px)': {
        marginBottom: 16,
      },
    },
  },
  uploadControl: {
    flex: '0 0 auto',
    whiteSpace: 'nowrap',
    '& button': {
      margin: 0,
      height: 43,
    },
    '@media(min-width: 1100px)': {
      marginBottom: 16,
    },
    '@media(max-width: 600px)': {
      width: '100%',
    },
  },
  voucherChips: {
    flex: '0 0 100%',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 5,
  },
  voucherField: {
    position: 'relative',
    paddingRight: '0!important',
    paddingLeft: '0!important',
    '@media(min-width: 1100px)': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-end',
      gap: 8,
      '& $blockField': {
        flex: '0 0 100%',
      },
      '& $addVoucherWrapper': {
        flex: '0 0 auto',
      },
    },
  },
  blockFieldFirst: {
    marginLeft: 10,
    paddingRight: 8,
    '@media(max-width: 768px)': {
      paddingRight: '0!important',
    }
  },
  blockField: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexDirection: 'column',
    width: '100%',
    '& > div': {
      width: '100%',
    },
    '& .MuiGrid-container ': {
      width: 'auto',
    },
    '& label': {
      height: 20,
      marginBottom: 13,
    },
    '& input': {
      borderRadius: ' 8px 0  0 8px ',
      '@media(max-width: 768px)': {
        borderRadius: ' 8px ',

      }
    },
    '@media(min-width: 1100px)': {
      flexDirection: 'row',
      alignItems: 'center',
      width: 'auto',
      margin: '0',

    },
    '@media(min-width: 992px)': {
      width: '100%',
    },
  },
  listHeadLine: {
    fontSize: 12,
    listStyle: 'none',
    marginTop: theme.spacing(1.5),
    marginBottom: 5,
    paddingInlineStart: theme.spacing(0),
  },
  listHeadLineValue: {
    fontWeight: 'bold',
    fontSize: 12,
    listStyle: 'none',
    marginTop: theme.spacing(1.5),
    marginBottom: 5,
    paddingInlineStart: theme.spacing(0),
  },
}));

export const useStylesCustomTable = makeStyles((theme) => ({
  table: {
    borderRadius: '10px',
    overflow: 'hidden',

    marginTop: '10px',
    '& .MuiTableCell-root': {
      '& .MuiInputBase-root ': { marginTop: '0', marginBottom: '0' },
      '& .MuiFormControl-root': { marginTop: '0', marginBottom: '0' },
    },
  },
  tbody: {
    border: '1px solid #EEF0F2',
  },
  thead: {
    backgroundColor: 'inherit',
    border: '1px solid #EEF0F2',


  },

  tblock: {
    backgroundColor: '#F5F5F5',
  },

  tableWrapperMain: {
    overflowX: 'inherit',
    boxShadow: 'none!important',
    '@media(max-width: 992px)': {
      marginTop: '10px',
    },
  },
  tableWrapper: {
    width: '100%',
    overflowX: 'auto!important',
    '@media(min-width: 992px)': {
      width: '100%',
    },
  },
  addBusinessWrapper: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 15,
    alignItems: 'center',
    width: '31%',
    gap: '15px',

    '@media(min-width: 992px)': {
      flexDirection: 'column',
      paddingBottom: 0,
      alignItems: 'flex-start',
    },
    '@media(min-width: 1100px)': {
      flexDirection: 'row',
      paddingBottom: 0,
      alignItems: 'center',
    },
  },
  autocompleteWrapper: {
    width: '100%',

    '@media(min-width: 992px)': {
      width: '24.33%',
    },



    // marginInlineStart: theme.spacing(2),
  },
  blockField: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexDirection: 'column',
    width: '100%',
    padding: '0!important',
    '& div': {
      width: '100%',
    },
    '@media(min-width: 600px)': {
      flexDirection: 'row',
      alignItems: 'center',
      width: 'auto',
      margin: '0',


    },
    '@media(min-width: 992px)': {
      width: '50%',
    },
    '@media(max-width: 600px)': {
      padding: '0 8px!important',

    },
  },

  inputValue: {
    width: '200px',
  },

  addBusinessBtn: {
    borderRadius: '8px',
    width: '100%',
    position: 'relative',
    top: -4,
    borderTopLeftRadius: '8px!important', borderBottomLeftRadius: '8px!important',


    '@media(min-width: 600px)': {
      width: '38px',
    },
    '@media(min-width: 600px)': {
      borderRadius: '8px',
      borderTopLeftRadius: '0!important', borderBottomLeftRadius: '0!important',

      width: 'auto',

    },
  },
  label: {
    color: ' #455a64',
    fontSize: 13,
    marginBottom: 10,
    '&::before': {
      content: `"*"`,
      position: 'relative',
      left: '-5px',
      top: 0,
      color: '#ef5350',
      display: 'inline-block',
    }

  },
  addPro: {
    width: '100%',
    '@media(min-width: 992px)': {
      width: '21.33%',
    },
  },
  orText: {
    paddingInlineStart: theme.spacing(2),
    paddingInlineEnd: theme.spacing(2),
    width: '100%!important',
    marginBottom: '12px',
    textAlign: 'center',
    '@media(min-width: 992px)': {
      width: '4.33%!important',
    },
  },
}));


export const useStylesPreview = makeStyles((theme) => ({
  radioItem: {
    borderColor: '#ccc',
    backrgound: 'white',
    boxSizing: 'border-box',
    display: 'block',
    padding: '12px 16px',
    marginInlineStart: 0,
    transition: 'ease .2s background',
    width: '50%',
    textAlign: 'center',
    height: '42px',
    '&.active': {
      background: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      color: 'white',
    },
    '&:first-child': {
      borderTopLeftRadius: 6,
      borderBottomLeftRadius: 6,
      borderRight: 'none',
    },
    '&:last-child': {
      borderTopRightRadius: 6,
      borderBottomRightRadius: 6,
      borderLeft: 'none',
    },
  },
  radioItemBlock: {
    display: 'flex',
    background: '#f5f7fa',
    borderRadius: 8,
    minWidth: '24.3%',
    flexBasis: '24%',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: '1px solid #EEF0F2',

    '@media(max-width: 992px)': {
      minWidth: '100%',
      flexBasis: '100%',
    },
  },
  select: {
    backgroundColor: '#eceff1',
  },
  toolsPayStyle: {
    backgroundColor: '#eceff1',

    '&:.Mui-disabled': {

      backgroundColor: '#eceff1',
    }
  },
  percentPayStyle: {
    backgroundColor: '#eceff1!important',

    '&:.Mui-disabled': {

      backgroundColor: '#eceff1',
    }
  },
  amountPayStyle: {
    backgroundColor: '#eceff1!important',

    '&:.Mui-disabled': {

      backgroundColor: '#eceff1',
    }
  },
  radioText: {
    color: '#2b3940',
    fontSize: 14,
    display: 'inline-block',
    transition: 'ease .2s color',
    fontWeight: 'bold',
    '&.active': {
      color: 'white',
    },
  },
  options: {
    '& label': {
      margin: 0,
    },
  },
}));
